




import { defineComponent } from '@vue/composition-api';

const name = 'ttam-promotion-app-tips';
export default defineComponent({
  name,
});
